import {createContext, useContext} from 'react';
import {analyticsTrack, SNOWPLOW_SCHEMAS} from '../modules/analytics_utils';

export const AnalyticsEventContext = createContext();

export const useAnalyticsEvent = () => {
  const analyticsEventContext = useContext(AnalyticsEventContext);

  if(analyticsEventContext === undefined) {
    return {};
  }

  return analyticsEventContext;
};

const useAnalyticsEventsInternal = props => {
  const value = {
    trackTagClickEvent({name}, pathname, event) {
      const {tagClickEvent} = props;
      const {category, action} = tagClickEvent;

      let trackingDataSP = {};

      if(pathname && event) {
        const isBattlecardView = pathname.includes('/battlecard') && !pathname.includes('/edit');
        const isProfileView = pathname.startsWith('/profile') && !isBattlecardView;
        const clickViewSource = isProfileView ? 'board' : isBattlecardView ? 'battlecard' : 'search';

        const cardWrapper = event
          .currentTarget
          ?.closest('.card-tags')
          ?.previousSibling
          ?.querySelector('.card-static-html_body');

        const cardId = parseInt(cardWrapper?.getAttribute('data-ga-card-id'), 10);
        const boardId = parseInt(cardWrapper?.getAttribute('data-ga-board-id'), 10);
        const battlecardId = parseInt(cardWrapper?.getAttribute('data-ga-battlecard-id'), 10);
        const rivalId = parseInt(cardWrapper?.getAttribute('data-ga-rival-id'), 10);

        trackingDataSP = {
          schema: SNOWPLOW_SCHEMAS.cardInteraction,
          data: {
            label: null,
            view: clickViewSource,
            type: 'tag_click',
            cardType: 'klue_card'
          },
          context: []
        };

        if(cardId) {
          trackingDataSP.context.push({
            schema: SNOWPLOW_SCHEMAS.card,
            data: {id: cardId}
          });
        }

        if(rivalId) {
          trackingDataSP.context.push({
            schema: SNOWPLOW_SCHEMAS.board,
            data: {id: rivalId}
          });
        }

        if(battlecardId) {
          trackingDataSP.context.push({
            schema: SNOWPLOW_SCHEMAS.battleCard,
            data: {id: battlecardId}
          });
        }
      }

      if(category) {
        analyticsTrack({
          type: 'event',
          category,
          action: action || 'Tag Click',
          label: `${name}`
        }, trackingDataSP);
      }
    }
  };

  return value;
};

export const AnalyticsEventProvider = props => {
  const {tagClickEvent, children} = props;

  const value = useAnalyticsEventsInternal({tagClickEvent});

  return (
    <AnalyticsEventContext.Provider value={value}>
      {children}
    </AnalyticsEventContext.Provider>
  );
};

AnalyticsEventProvider.propTypes = {
  children: PropTypes.node.isRequired,
  tagClickEvent: PropTypes.shape({
    category: PropTypes.string.isRequired,
    action: PropTypes.string
  }).isRequired
};

AnalyticsEventProvider.defaultProps = {
  tagClickEvent: null
};
